export default [
  {
    id: '1',
    label: 'Animal Services',
    url: 'images/Animal Services',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_05.png'
    ]
  },
  {
    id: '2',
    label: 'Auto Sales and Service',
    url: 'images/Auto Sales',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Auto%20Sales',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Auto%20Sales/Auto_Sales_Auto_Sales_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Auto%20Sales/Auto_Sales_Auto_Sales_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Auto%20Sales/Auto_Sales_Auto_Sales_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Auto%20Sales/Auto_Sales_Auto_Sales_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Auto%20Sales/Auto_Sales_Auto_Sales_Sample_05.png'
    ]
  },
  {
    id: '3',
    label: 'Child/Education Services',
    url: 'images/Education',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Education',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Education/Education_Education_Services_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Education/Education_Education_Services_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Education/Education_Education_Services_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Education/Education_Education_Services_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Education/Education_Education_Services_Sample_05.png'
    ]
  },
  {
    id: '4',
    label: 'CPG - Food and Beverage',
    url: 'images/Home',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Home',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_05.png'
    ]
  },
  {
    id: '5',
    label: 'CPG - Frictionless Payment',
    url: 'images/Home',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Home',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_05.png'
    ]
  },
  {
    id: '6',
    label: 'CPG - Household',
    url: 'images/Home',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Home',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_05.png'
    ]
  },
  {
    id: '7',
    label: 'CPG - OTC/Beauty',
    url: 'images/Home',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Home',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_05.png'
    ]
  },
  {
    id: '8',
    label: 'CPG - Pharmaceuticals',
    url: 'images/Plasma Services',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services/Plasma_Services_Plasma_Service_Samples_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services/Plasma_Services_Plasma_Service_Samples_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services/Plasma_Services_Plasma_Service_Samples_03.png'
    ]
  },
  {
    id: '9',
    label: 'Dental/Orthodontic Services',
    url: 'images/Dental',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Dental',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Dental/Dental_Dental_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Dental/Dental_Dental_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Dental/Dental_Dental_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Dental/Dental_Dental_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Dental/Dental_Dental_Sample_05.png'
    ]
  },
  {
    id: '10',
    label: 'Financial Services',
    url: 'images/Insurance',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_05.png'
    ]
  },
  {
    id: '11',
    label: 'Fitness Services',
    url: 'images/Fitness',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Fitness',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Fitness/Fitness_Fitness_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Fitness/Fitness_Fitness_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Fitness/Fitness_Fitness_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Fitness/Fitness_Fitness_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Fitness/Fitness_Fitness_Sample_05.png'
    ]
  },
  {
    id: '12',
    label: 'Healthcare Services - Hospitals',
    url: 'images/Urgent Care and Hospitals',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Urgent%20Care%20and%20Hospitals',
    images: []
  },
  {
    id: '13',
    label: 'Healthcare Services - Plasma Services',
    url: 'images/Plasma Services',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services/Plasma_Services_Plasma_Service_Samples_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services/Plasma_Services_Plasma_Service_Samples_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Plasma%20Services/Plasma_Services_Plasma_Service_Samples_03.png'
    ]
  },
  {
    id: '14',
    label: 'Healthcare Services - Primary Care',
    url: 'images/Urgent Care and Hospitals',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Urgent%20Care%20and%20Hospitals',
    images: []
  },
  {
    id: '15',
    label: 'Healthcare Services - Specialists',
    url: 'images/Urgent Care and Hospitals',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Urgent%20Care%20and%20Hospitals',
    images: []
  },
  {
    id: '16',
    label: 'Home & Auto Insurance',
    url: 'images/Insurance',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_05.png'
    ]
  },
  {
    id: '17',
    label: 'Home Improvement',
    url: 'images/Home',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Home',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_05.png'
    ]
  },
  {
    id: '18',
    label: 'Home Furniture and Accessories',
    url: 'images/Home',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Home',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Home/Home_Home_Sample_05.png'
    ]
  },
  {
    id: '19',
    label: 'Legal Services',
    url: 'images/Legal',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Legal',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Legal/Legal_Legal_Services_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Legal/Legal_Legal_Services_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Legal/Legal_Legal_Services_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Legal/Legal_Legal_Services_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Legal/Legal_Legal_Services_05.png'
    ]
  },
  {
    id: '20',
    label: 'Media',
    url: 'images/Entertainment',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_05.png'
    ]
  },
  {
    id: '21',
    label: 'Medical Insurance',
    url: 'images/Insurance',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Insurance/Insurance_Insurance_Sample_05.png'
    ]
  },
  {
    id: '22',
    label: 'Non-Profit',
    url: 'images/Healthcare Services',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Healthcare%20Services',
    images: []
  },
  {
    id: '23',
    label: 'Personal Services',
    url: 'images/Animal Services',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Animal%20Services/Animal_Services_Animal_Services_Samples_05.png'
    ]
  },
  {
    id: '24',
    label: 'Real Estate Services',
    url: 'images/Real Estate',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Real%20Estate',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Real%20Estate/Real_Estate_Real_Estate_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Real%20Estate/Real_Estate_Real_Estate_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Real%20Estate/Real_Estate_Real_Estate_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Real%20Estate/Real_Estate_Real_Estate_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Real%20Estate/Real_Estate_Real_Estate_Sample_05.png'
    ]
  },
  {
    id: '25',
    label: 'Senior Living/Services',
    url: 'images/Senior Living',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Senior%20Living',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Senior%20Living/Senior_Living_Senior_Living_Samples_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Senior%20Living/Senior_Living_Senior_Living_Samples_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Senior%20Living/Senior_Living_Senior_Living_Samples_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Senior%20Living/Senior_Living_Senior_Living_Samples_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Senior%20Living/Senior_Living_Senior_Living_Samples_05.png'
    ]
  },
  {
    id: '26',
    label: 'Travel/Leisure/Entertainment',
    url: 'images/Travel',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Travel',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Travel/Travel_Travel_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Travel/Travel_Travel_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Travel/Travel_Travel_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Travel/Travel_Travel_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Travel/Travel_Travel_Sample_05.png'
    ]
  },
  {
    id: '27',
    label: 'Wedding Services',
    url: 'images/Entertainment',
    fullUrl: 'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment',
    images: [
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_01.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_02.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_03.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_04.png',
      'https://d3s0ds5k8kdjce.cloudfront.net/images/Entertainment/Entertainment_Entertainment_Sample_05.png'
    ]
  }
];
